import React, { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import CustomInput from 'src/app/shared/components/common/input'
import { useTranslation } from 'react-i18next'
import { Flex, Typography } from 'antd'
import { capitalizeFirstLetter, inputNumber } from 'src/app/shared/utils'
import { colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'

const CheckForm: React.FC<any> = (props: any) => {
  const { control } = props;
  const { t } = useTranslation()

  return (
    <Flex vertical>
      <Typography.Text style={{ fontSize: '18px', fontWeight: '700', lineHeight: '28px', paddingBottom: '4px' }}>
        {t('AllTransactions:viewTransaction.check.title')}
      </Typography.Text>

      <Flex vertical style={{ border: `1px solid ${colorBorderDisabled}`, padding: '16px', borderRadius: '16px' }}>
        <Flex style={{ gap: 24, marginBottom: "24px" }}>
          <Controller
            control={control}
            name='checkNumber'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.check_number')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
          <Controller
            control={control}
            name='issuedPayee'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.issued_payee')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
        </Flex>
        <Flex style={{ gap: 24, marginBottom: "24px" }}>
          <Controller
            control={control}
            name='payeeMatchConfidence'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.payee_match')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
          <Controller
            control={control}
            name='foundPayee'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.found_payee')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
        </Flex>
        <Flex style={{ gap: 24, marginBottom: "24px" }}>
          <Controller
            control={control}
            name='imageFound'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.image_found')}
                value={[true, false]?.includes(field?.value) ? capitalizeFirstLetter(field.value?.toString()) : ""}
                onChange={(e) => field.onChange(inputNumber(e), { shouldValidate: true })}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
          <Controller
            control={control}
            name='issuedDate'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.issued_date')}
                value={field.value}
                onChange={(e) => field.onChange(inputNumber(e), { shouldValidate: true })}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
        </Flex>
        <Flex style={{ gap: 24 }}>
          <Controller
            control={control}
            name='staleDatedAsOf'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.stale_dated')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
          <Controller
            control={control}
            name='voidDate'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.check.void_date')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default CheckForm
